import React from 'react';

import GridContainer from './GridContainer';
import GridContents from './GridContents';

export default function GridContentsTab({gridId}: {gridId: string}): JSX.Element {
  return <GridContainer gridId={gridId}>{(childProps) => <GridContents {...childProps} />}</GridContainer>;
}
